import * as actionTypes from './actionsTypes';

export const setstudentdegree = (payload) => {
    return {
        type: actionTypes.SETSTUDENTDEGREE,
        value: payload
    }
}